import { Origin, OriginStatus } from "@/domain/entities/Origin";
import { ICreateOriginProtocol, ICreateOriginProtocolRequest, ICreateOriginProtocolResponse } from "../../protocols/origin/ICreateOriginProtocol";
import { IOriginsRepository } from "../../repositories/IOriginsRepository";

export class CreateOriginUseCase implements ICreateOriginProtocol {
  constructor(private originsRepository: IOriginsRepository){}
  async execute({name, status, type}: ICreateOriginProtocolRequest): Promise<ICreateOriginProtocolResponse> {
    const originAlreadyExists = await this.originsRepository.findByName(name)

    if(originAlreadyExists){
      throw new Error('Origin already exists.')
    }

    const origin = Origin.create({
      name,
      status,
      type
    })

    await this.originsRepository.create(origin)

    return {
      origin
    }
  }
}